import { useCubohActionBar } from 'hooks/useCubohActionBar';
import { useAuth } from 'hooks/useAuth';

import { Button, Menu, ScrollArea, Space } from '@mantine/core';

import { ChevronDownIconXs } from '@chownow/pantry/icons';
export default function CubohMerchantSelector() {
  const {
    actionBarSingleSelectedOption,
    setActionBarSingleSelectedOption,
    selectOptions,
    singleSelectedCompanyID,
    merchantsForSelectedCompany,
  } = useCubohActionBar();

  const selectedOptionObject =
    actionBarSingleSelectedOption && JSON.parse(actionBarSingleSelectedOption);

  const { merchants } = useAuth();

  // there is only 1 merchant, no merchant selector needed
  if (merchantsForSelectedCompany.length === 1) {
    return null;
  }

  const selectOptionToUse = selectOptions.filter(
    ({ key }) => Number(JSON.parse(key)?.companyID) === Number(singleSelectedCompanyID),
  );
  const allMerchantOption = selectOptionToUse[0] || {};

  const displayValue = !selectedOptionObject?.merchantID
    ? 'All Merchants'
    : merchants[selectedOptionObject?.merchantID]?.name;

  return (
    <Menu position="bottom-start">
      <Menu.Target>
        <Button
          variant="outline"
          size="sm"
          rightSection={<ChevronDownIconXs />}
          style={{ borderRadius: 'var(--mantine-radius-xs)' }}
        >
          {displayValue}
        </Button>
      </Menu.Target>
      <Menu.Dropdown w="280px" maw="280px">
        <ScrollArea.Autosize mah="70vh">
          <Menu.Item
            value={allMerchantOption.value}
            key={allMerchantOption.key}
            onClick={() => setActionBarSingleSelectedOption(allMerchantOption.value)}
          >
            All Merchants
          </Menu.Item>
          {allMerchantOption.children?.map(child => (
            <Menu.Item
              value={child.value}
              key={child.key}
              onClick={() => setActionBarSingleSelectedOption(child.value)}
            >
              {child.title}
            </Menu.Item>
          ))}
        </ScrollArea.Autosize>
      </Menu.Dropdown>
      <Space h="md" />
    </Menu>
  );
}
